import axios from "axios"
import { useEffect, useState } from "react"
import { useParams } from "react-router-dom"


const NewsFeedTrendPage = () => {
  const { trendId } = useParams()
  const [trendData, setTrendData] = useState(null)

  const getTrendData = async () => {
    const response = await axios.get(`/api/news-feed/trend/${encodeURIComponent(trendId)}`)
    setTrendData(response.data)
  }
  const deleteProduct = async (productUrl) => {
    const response = await axios.delete(`/api/news-feed/reviewed-products/trend/${encodeURIComponent(trendId)}?productUrl=${encodeURI(productUrl)}`)
    getTrendData()
  }


  const addProduct = async () => {
    const imageUrl = document.querySelector('#reviewedProductsImageUrl').value
    document.querySelector('#reviewedProductsImageUrl').value = ""
    const productUrl = document.querySelector('#reviewedProductsProductUrl').value
    document.querySelector('#reviewedProductsProductUrl').value = ""
    const response = await axios.post(`/api/news-feed/reviewed-products/trend/${encodeURIComponent(trendId)}`, { imageUrl, productUrl })
    getTrendData()
  }

  useEffect(() => {
    getTrendData()
  }, [trendId])

  return <div>
    {trendData ? <div className="p-4">
      <div className="p-4">
        <p>Gender:{trendData.gender}</p>
        <p>Category:{trendData.category}</p>
        <p>{trendData.tag}:{trendData.value}</p>
      </div>

      <div className="flex h-60 w-screen overflow-x-scroll border border-slate-300">
        {trendData.images.map(img => <img className="min-w-40 mx-2 shrink-0" loading="lazy" src={img.imageUrl} />)}
      </div>
      <div>
        <table className="w-full border  m-4">
          <thead>
            <tr>
              <th className="border">Product Url</th>
              <th className="border">Image Url</th>
              <th className="border">Delete Product</th>
            </tr>
          </thead>
          <tbody>

            {trendData.reviewedProducts.map(p => <tr key={p.productUrl}>
              <td className="border text-center p-1 ">{p.productUrl}</td>
              <td className="border text-center p-1">
                <img
                  src={p.imageUrl}
                  className="w-40 m-auto"
                />
                {p.imageUrl}

              </td>
              <td className="border">
                <button
                  className="primary-btn"
                  onClick={() => {
                    deleteProduct(p.productUrl)
                  }}>DELETE</button>
              </td>
            </tr>)}
            <tr>
              <td className="border">
                <div className="flex justify-center">
                  <input id="reviewedProductsProductUrl" className="p-2 rounded bg-slate-50 my-2 text-sm w-[90%] border " placeholder="Enter Product URL" />
                </div>
              </td>
              <td className="border">
                <div className="flex justify-center border">
                  <input id="reviewedProductsImageUrl" cclassName="p-2 rounded bg-slate-50 my-2 text-sm w-full border-2 " placeholder="Enter Image URL" />
                </div>
              </td>
              <td>
                <button
                  className="primary-btn"
                  onClick={(e) => {
                    addProduct()
                  }}>ADD PRODUCT</button>
              </td>
            </tr>
          </tbody>
        </table>

      </div>
    </div> : null}
  </div>
}

export default NewsFeedTrendPage
